module.exports = "/packs/step4-a0b06a751b6e274747af159d7da64e5a.png";